<template>
  <main class="about-main page bot-pad">
    <div class="app">
      <div class="container">
        <Suspense>
          <router-view key="$route.path"></router-view>
        </Suspense>
      </div>
    </div>
  </main>
</template>

<script>
  import { useRoute } from 'vue-router'

  export default {
    name: 'App',
    created() {
      const currentStartPath = window.location.pathname.split('/')[1];
      const language = window.__LANGUAGE__;
      console.log('Current Start path:', currentStartPath);
      // console.log('i18n',this.locale)
      console.log('language',language)
      // Use the currentLanguage variable to customize the component behavior based on the current language
    },
    components: {
      // HeaderCs,
      // FooterCs
    },
    setup() {
      const route = useRoute() 
    }
  }
</script>
<style>
  #app {
    font-family: 'Assistant', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    font-family: 'Assistant', sans-serif;
    background-color: #fff;
    /* direction: rtl; */
    min-height: 100vh;
    transition: 0.3s;
  }
  #app a{
    text-decoration: none !important;
  }
  .h-100{
    height: 100%;
  }
</style>
